import { useMutation, useQuery } from '@tanstack/react-query';
import { get } from 'lodash-es';
import { useTranslation } from 'react-i18next';

import { tenantApi } from '@/api';
import { QUERY_KEY_CONST, QUERY_META_CONST, TENANT_CONST } from '@/constant';
import { useVToast } from '@/package';
import type { TenantApi } from '@/type';

export const useTenantUpdatePlanMutation = () => {
  const { addToast } = useVToast();
  const { t } = useTranslation();

  return useMutation({
    mutationFn: (param: TenantApi.UpdatePlan.Request) =>
      tenantApi.updatePlan(param),
    onError(error, { tier }) {
      if (
        get(error, 'data.resultCode') === '1400' &&
        tier === TENANT_CONST.TIER.FREETIER
      ) {
        addToast({
          message: t('admin.changePlanError1400.helpmate'),
          autoClose: true,
          variant: 'error',
        });
      } else {
        addToast({
          message: error.message,
          autoClose: true,
          variant: 'error',
        });
      }
    },
    meta: {
      [QUERY_META_CONST.META_KEY.OVERRIDE_GLOBAL_ERROR_HANDLER]: true,
    },
  });
};

export const useTenantUsageQuery = () => {
  return useQuery({
    queryKey: [QUERY_KEY_CONST.TENANT_KEYS.getUsage()],
    queryFn: () => tenantApi.getUsage().then(res => res.data.resultData),
  });
};
